export default __webpack_public_path__ + "static/media/img1.05874591.jpg";